// ============================================
// CHAPTER LIST - PROCESSING MODAL
// Lista os capítulos extraídos do JSON processado
// ============================================
import React, { Component, Fragment } from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'
import { processingModalStyles } from './styles'

class ChapterList extends Component {
  render() {
    const { classes, chapters, onRegisterChapter } = this.props

    if (!chapters || chapters.length === 0) {
      return (
        <div className={classes.emptyBox}>
          <Typography variant="body1">Nenhum capítulo encontrado.</Typography>
        </div>
      )
    }

    return (
      <Fragment>
        {chapters.map((chapter, index) => {
          const hasContent = !!(chapter.conteudoHtml || chapter.conteudo)
          const idVetor = chapter.idVetor || chapter.id_vetor || chapter.id || ''
          const existingContent = chapter.cmsContent || null
          const pages = chapter.paginas || {}
          const pageStart = chapter.page_start || pages.start || pages.inicio || '?'
          const pageEnd = chapter.page_end || pages.end || pages.fim || '?'

          return (
            <div key={(idVetor || 'chapter') + '-' + index} className={classes.chapterItem}>
              {/* Info do Capítulo */}
              <div className={classes.chapterInfo}>
                <Typography variant="body1" className={classes.chapterTitle}>
                  {chapter.titulo || chapter.capitulo || 'Sem título'}
                </Typography>
                <Typography variant="caption" className={classes.chapterMeta}>
                  Páginas: {pageStart} - {pageEnd}
                  {' | '}
                  idVetor: {idVetor ? idVetor.substring(0, 8) + '...' : 'ausente'}
                </Typography>
              </div>

              {/* Ações */}
              <div className={classes.chapterActions}>
                {/* Feedback Visual de Status */}
                {existingContent ? (
                  <Chip
                    label="Já cadastrado no CMS"
                    style={{ backgroundColor: '#ff9800', color: '#fff', marginRight: 8 }}
                    size="small"
                  />
                ) : !idVetor ? (
                  <Chip label="Sem idVetor" color="default" size="small" style={{ marginRight: 8 }} />
                ) : hasContent ? (
                  <Chip
                    label="HTML disponível"
                    color="primary"
                    size="small"
                    variant="outlined"
                    style={{ marginRight: 8 }}
                  />
                ) : (
                  <Chip label="Sem HTML" color="default" size="small" style={{ marginRight: 8 }} />
                )}

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={!hasContent || !idVetor}
                  onClick={() => onRegisterChapter(chapter, index)}
                >
                  {existingContent ? 'Revisar / substituir' : 'Revisar e cadastrar'}
                </Button>
              </div>
            </div>
          )
        })}
      </Fragment>
    )
  }
}

export default withStyles(processingModalStyles)(ChapterList)



// WEBPACK FOOTER //
// ./src/containers/BookVectorization/ProcessingModal/ChapterList.js